import api from './client';

// Exchange Rates API
export const exchangeRatesAPI = {
  getLatest: () => api.get('/fx/rates'),
  refresh: () => api.post('/fx/refresh'),
};
